import { render } from "./Tem008.vue?vue&type=template&id=3fbe6e4b"
import script from "./Tem008.vue?vue&type=script&lang=js"
export * from "./Tem008.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__